import PropTypes from 'prop-types';
import EspotList from '@/components/common/InfoCardList/EspotList';
import ESpot from '@/components/layout/espots/ESpot';
import { ESPOT_TYPE } from '@/constants/espot';
import { useAppSelector } from '@/redux';

const EspotContainer = ({ espot, customClassName }) => {
	const locale = useAppSelector(({ root }) => root.storeConf.locale);

	return espot.type === ESPOT_TYPE.LIST ? (
		<EspotList data={espot} />
	) : (
		<ESpot spot={espot} locale={locale} customClassName={customClassName} />
	);
};

EspotContainer.propTypes = {
	espot: PropTypes.shape({
		type: PropTypes.string.isRequired,
	}).isRequired,
	customClassName: PropTypes.string,
};

export default EspotContainer;
